module.exports = __webpack_public_path__ + "img/ss.f7118c09.png";